import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { forkJoin, Observable } from 'rxjs';
import { DialogService } from '../../_services/dialog.service';
import { PledgePerWin } from '../../_models/fundraising/ppw/PledgePerWin';
import { PledgePerWinService } from '../../_services/fundraising/pledgePerWin.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    templateUrl: './ppw-sort-order-modal.component.html',
    styleUrls: ['./games/ppw-game-confirm-modal.component.css']
  })

export class PledgePerWinSortOrderModalComponent implements OnInit{

    public ppwId: number;
    public ppw: PledgePerWin;
    public ppws: PledgePerWin[];

    @Output()
    public sortOrderChanged = new EventEmitter;

    public form: FormGroup;

    public counter = new Array(100);

    private hasValidationErrors: boolean;

    constructor(
        private ppwService: PledgePerWinService,
        private fb: FormBuilder,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef,
        private bsModalRef: BsModalRef,
        private spinner: NgxSpinnerService
    ){}

    ngOnInit(){
        this.ppw = this.ppws.find(ppw => ppw.pledgePerWinId == this.ppwId);
        this.createForm(this.ppw);
    }

    createForm(ppw: PledgePerWin){
        this.form = this.fb.group({
            sortOrder: [ppw?.sortOrder || 0, [Validators.required, Validators.min(1)]]
        });
    }

    saveAndClose(){
        this.hasValidationErrors = !this.form.valid;
        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        if (this.hasValidationErrors) {
            this.form.markAllAsTouched();
            this.form.markAsDirty();
            return;
        }

        this.spinner.show();
        this.ppwService.updateSortOrder(this.ppwId, this.form.controls.sortOrder.value)
            .subscribe(res => {
                this.spinner.hide();
                this.close();
                this.dialogService.alert("Success", "Sort Order successfully updated!", this.viewRef)
                    .then(_ => {
                        this.sortOrderChanged.emit();
                    })
            }, error => {
                this.spinner.hide();
                this.close();
                this.dialogService.alert("Uh oh!", "Something went wrong trying to update this PPW.", this.viewRef);
            });
    }
      
    close() {
        this.bsModalRef.hide();
    }
}